// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GenericSummary .nav.nav-tabs {
  display: flex;
  align-items: flex-end;
  padding-left: 0 !important;
  margin-bottom: 20px;
  border-bottom: 2px solid #e9ecef;
  list-style: none !important;
}

.GenericSummary .nav-tabs .nav-item {
  list-style: none !important;
  margin-bottom: 0 !important;
}

.GenericSummary .nav-tabs .nav-item::marker {
  content: '' !important;
}

.GenericSummary .nav-tabs .nav-item::before,
.GenericSummary .nav-tabs .nav-item::after {
  content: '' !important;
}

.GenericSummary .nav-tabs .nav-link.active {
  box-shadow: inset 0 -2px 0 #17a2b8;
  border: none;
}

.GenericSummary {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}

.GenericSummary__tabs {
  flex: 0 0 auto;
}

.GenericSummary__content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: visible;
  padding-left: 0 !important;
}

.GenericSummary__content > :first-child {
  margin-top: 0;
}

.GenericSummary .nav.nav-tabs {
  display: flex;
  align-items: flex-end;
  padding-left: 0 !important;
  margin: 0 0 20px 0 !important;
  border-bottom: 2px solid #e9ecef;
  list-style: none !important;
}

.GenericSummary .nav.nav-tabs > .nav-item {
  display: block !important;
  list-style: none !important;
  margin-bottom: 0 !important;
}

.GenericSummary .nav.nav-tabs > .nav-item::marker {
  content: none !important;
}
.GenericSummary .nav.nav-tabs > .nav-item::before,
.GenericSummary .nav.nav-tabs > .nav-item::after {
  content: '' !important;
}

.GenericSummary .nav-tabs .nav-link.active {
  box-shadow: inset 0 -2px 0 #17a2b8;
  border: none;
}

@media (max-width: 767px) {
  /* Make the tab bar scroll horizontally instead of wrapping */
  .nav.nav-tabs {
    flex-wrap: nowrap !important;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
    /* keep the bottom border visible */
    padding-bottom: 2px;
  }

  .nav.nav-tabs::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }

  /* Prevent individual tabs from shrinking */
  .nav-tabs .nav-item {
    flex: 0 0 auto;
  }

  /* Slightly tighter tab text on mobile */
  .nav-tabs .nav-link {
    font-size: 14px;
    padding: 8px 14px;
    white-space: nowrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GenericSummary/GenericSummary.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;AACA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,EAAE,YAAY;IACtC,mCAAmC;IACnC,mBAAmB;EACrB;;EAEA;IACE,aAAa,EAAE,kBAAkB;EACnC;;EAEA,2CAA2C;EAC3C;IACE,cAAc;EAChB;;EAEA,wCAAwC;EACxC;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;AACF","sourcesContent":[".GenericSummary .nav.nav-tabs {\n  display: flex;\n  align-items: flex-end;\n  padding-left: 0 !important;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #e9ecef;\n  list-style: none !important;\n}\n\n.GenericSummary .nav-tabs .nav-item {\n  list-style: none !important;\n  margin-bottom: 0 !important;\n}\n\n.GenericSummary .nav-tabs .nav-item::marker {\n  content: '' !important;\n}\n\n.GenericSummary .nav-tabs .nav-item::before,\n.GenericSummary .nav-tabs .nav-item::after {\n  content: '' !important;\n}\n\n.GenericSummary .nav-tabs .nav-link.active {\n  box-shadow: inset 0 -2px 0 #17a2b8;\n  border: none;\n}\n\n.GenericSummary {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n}\n\n.GenericSummary__tabs {\n  flex: 0 0 auto;\n}\n\n.GenericSummary__content {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: visible;\n  padding-left: 0 !important;\n}\n\n.GenericSummary__content > :first-child {\n  margin-top: 0;\n}\n\n.GenericSummary .nav.nav-tabs {\n  display: flex;\n  align-items: flex-end;\n  padding-left: 0 !important;\n  margin: 0 0 20px 0 !important;\n  border-bottom: 2px solid #e9ecef;\n  list-style: none !important;\n}\n\n.GenericSummary .nav.nav-tabs > .nav-item {\n  display: block !important;\n  list-style: none !important;\n  margin-bottom: 0 !important;\n}\n\n.GenericSummary .nav.nav-tabs > .nav-item::marker {\n  content: none !important;\n}\n.GenericSummary .nav.nav-tabs > .nav-item::before,\n.GenericSummary .nav.nav-tabs > .nav-item::after {\n  content: '' !important;\n}\n\n.GenericSummary .nav-tabs .nav-link.active {\n  box-shadow: inset 0 -2px 0 #17a2b8;\n  border: none;\n}\n\n@media (max-width: 767px) {\n  /* Make the tab bar scroll horizontally instead of wrapping */\n  .nav.nav-tabs {\n    flex-wrap: nowrap !important;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE/Edge */\n    /* keep the bottom border visible */\n    padding-bottom: 2px;\n  }\n\n  .nav.nav-tabs::-webkit-scrollbar {\n    display: none; /* Chrome/Safari */\n  }\n\n  /* Prevent individual tabs from shrinking */\n  .nav-tabs .nav-item {\n    flex: 0 0 auto;\n  }\n\n  /* Slightly tighter tab text on mobile */\n  .nav-tabs .nav-link {\n    font-size: 14px;\n    padding: 8px 14px;\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
